import { pushSnackbar } from "@pocketsign/design-system";

export const STORE_CONSOLE_SNACKBAR_TOASTER_ID = "store-console";

type StoreConsoleSnackbarType = "error" | "success";

function pushStoreConsoleSnackbar(
  type: StoreConsoleSnackbarType,
  title: string,
) {
  return pushSnackbar({
    toasterId: STORE_CONSOLE_SNACKBAR_TOASTER_ID,
    type,
    title,
  });
}

export function pushStoreConsoleError(title: string) {
  return pushStoreConsoleSnackbar("error", title);
}

export function pushStoreConsoleSuccess(title: string) {
  return pushStoreConsoleSnackbar("success", title);
}
